const inScopeFeatures = window.inScopeFeatures || [];

export function featureInScope() {
    function inScope(feature) {
        return window.inScopeFeatures.includes(feature);
    }

    return { inScope };
}
